import axios from "axios";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: BASE });

export const getConfig = () => api.get("/config").then((r) => r.data);
export const updateConfig = (payload) => api.put("/config", payload).then((r) => r.data);

export const listAudit = (params = {}) =>
  api.get("/audit", { params }).then((r) => r.data);
export const createAudit = (payload) => api.post("/audit", payload).then((r) => r.data);
export const clearAudit = () => api.delete("/audit").then((r) => r.data);

export const listRoles = (role) =>
  api.get("/roles", { params: role ? { role } : {} }).then((r) => r.data);
export const upsertRole = (payload) => api.post("/roles", payload).then((r) => r.data);

export const listBlacklist = (activeOnly = false) =>
  api.get("/blacklist", { params: { active_only: activeOnly } }).then((r) => r.data);
export const upsertBlacklist = (payload) =>
  api.post("/blacklist", payload).then((r) => r.data);

export const getStats = () => api.get("/stats").then((r) => r.data);
